import { persistStore } from 'redux-persist';

export default persistStore;
